import * as a from './actions'
import * as m from './mutations'
import * as g from './getters'

export { default as state } from './state'
export const actions = { ...a }
export const mutations = { ...m }
export const getters = { ...g }
